<template>
  <div id="app">
    <router-view/>
  </div>
</template>
	<script>
		import cookies from 'js-cookie'	
		export default{
			name: 'app',
			provide(){
				return {
					reload: this.reload
				}
			},
			data(){
				return {
					isRouterAlive:true,
					beforeUnloadTime: '',
      				gapTime: ''
				}
			},
			 mounted:function(){
					window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
					window.addEventListener('unload', e => this.unloadHandler(e))

					
			},
			destroyed:function(){
					window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
					window.removeEventListener('unload', e => this.unloadHandler(e))
					localStorage.clear()
					window.console.log('关闭窗口!')

			},
	
			methods:{
					
					beforeunloadHandler(){
							this.beforeUnloadTime=new Date().getTime();
					},

					unloadHandler(e){
							this.gapTime=new Date().getTime()-this.beforeUnloadTime;
							//close window or refresh
							if(this.gapTime<=5){
							//close browser
							 
							//this.$http.get('/yj?op=loginOut').then(function(res){							
					
							//},function(){
								
							//});
							//clear local cookie
							//cookies.set('token', '');
							//cookies.set('token_uuid', '');

							}
					},

				reload(){
					this.isRouterAlive = false;
					this.$nextTick(function(){
						this.isRouterAlive = true
					})
				}
			}
    }
    
  </script>